# Keeps a manually edited emboss line within the rules the server validates in
# app/validators/emboss_validator.rb (/\A[A-Z0-9\s]+\z/, at most
# EmbossValidator::MAX_LENGTH characters) by converting the value as it is
# typed, the same way `prefill-emboss-line` converts the name fields it copies
# from.

import { EMBOSS_LINE_MAX_LENGTH, embossCharacters, embossLine } from 'shared/helpers/emboss_line'

SELECTOR = '[data-behaviour="emboss-line"]'

# How much room the card leaves for this field. Defaults to what the server
# validates, `data-max-length` overrides it for a field that has less.
maxLengthOf = (input) -> $(input).data('max-length') || EMBOSS_LINE_MAX_LENGTH

# The `maxlength` attribute caps what can be typed, but not what the conversion
# adds on top of it (Ü -> UE, ß -> SS).
convertTyped = (input, value) -> embossCharacters(value).slice(0, maxLengthOf(input))

# Converts in place and keeps the caret in front of the same characters, the
# conversion can change the length of everything before it.
convertWhileTyping = (input) ->
  converted = convertTyped(input, input.value)
  return if converted == input.value

  caret = convertTyped(input, input.value.slice(0, input.selectionEnd ? input.value.length)).length
  input.value = converted
  input.setSelectionRange?(caret, caret)

# Once the field is left the surrounding spaces go as well - while typing they
# have to stay, they are what separates the first name from the last one.
convert = (input) ->
  converted = embossLine(input.value, maxLengthOf(input))
  input.value = converted unless converted == input.value

# Dead keys (^ + a -> â) and other IME input arrive as a composition. Rewriting
# the value in the middle of one cancels it, so wait for it to finish.
composing = (input) -> $(input).data('emboss-line-composing')

init = ->
  $(SELECTOR).each -> convert(@)

$(document).on 'compositionstart', SELECTOR, -> $(@).data('emboss-line-composing', true)

$(document).on 'compositionend', SELECTOR, ->
  $(@).data('emboss-line-composing', false)
  convertWhileTyping(@)

$(document).on 'input', SELECTOR, -> convertWhileTyping(@) unless composing(@)

$(document).on 'change blur', SELECTOR, -> convert(@)

$(document).ready(init)
